import gql from 'graphql-tag';

export const SYNC_MEMBER_PERSONALISATION_MUTATION = gql`
mutation SyncMemberPersonalisationData($offerId: Int!) {
    updateAspirexMemberFieldsForOffer(offerId: $offerId)
}
`;
